import React from "react"
import classes from './LessonsBtnMenu.module.css'

const LessonsBtnMenu = ({ setNochildChosen, currentBtn, changeBtn, btnList, childIsChosen, HiddenText }) => {

    const handleClick = (index) => {
        changeBtn(index)
        if (setNochildChosen)
            setNochildChosen(0)
    }
    return (
        <div className={classes.MenuBtn}>
            {btnList.map((b, index) =>
                <button key={index} title={b.text} className={`${classes.Btn} ${HiddenText ? classes.Hidden : ''}  ${index === currentBtn && !childIsChosen ? classes.CurrentBtn : childIsChosen && index === currentBtn && classes.ChildIsChosen}`} onClick={() => handleClick(index)}>
                    <img src={b.icon} alt="Icon"/>
                    <h4 className={`${classes.Text} ${HiddenText ? classes.HiddenText : ''}`}>{b.text}</h4>
                </button>
            )}
        </div>
    )
}

export default LessonsBtnMenu;